'use client';

const FINGERPRINT_STORAGE_KEY = 'X_FINGERPRINT';

/** Exact mirror of frontend/src/app/core/utils/fingerprint.util.ts. Keeping the
 * components and hash identical means the parent marketing page and the
 * cross-origin Demoapt iframe independently produce the same device identity. */
export function getDemoFingerprint(): string {
  const stored = localStorage.getItem(FINGERPRINT_STORAGE_KEY);
  if (stored) return stored;

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context?.fillText('Analytics fingerprint', 10, 10);
  const canvasFingerprint = canvas.toDataURL();
  const navigatorWithMemory = navigator as Navigator & {
    deviceMemory?: number;
  };
  const components = [
    navigator.userAgent,
    navigator.language,
    navigator.platform,
    navigator.cookieEnabled.toString(),
    navigator.doNotTrack || 'unknown',
    `${screen.width}x${screen.height}`,
    screen.colorDepth.toString(),
    new Date().getTimezoneOffset().toString(),
    canvasFingerprint.slice(-50),
    navigator.hardwareConcurrency?.toString() || 'unknown',
    navigatorWithMemory.deviceMemory?.toString() || 'unknown',
  ];

  let hash = 0;
  const value = components.join('|');
  for (let index = 0; index < value.length; index++) {
    hash = (hash << 5) - hash + value.charCodeAt(index);
    hash &= hash;
  }
  const fingerprint = `fp_${Math.abs(hash).toString(36)}`;
  localStorage.setItem(FINGERPRINT_STORAGE_KEY, fingerprint);
  return fingerprint;
}

export function demoBrowserContext(fingerprint: string): string {
  return browserContext(fingerprint, 'demo');
}

export function websiteBrowserContext(fingerprint: string): string {
  return browserContext(fingerprint, 'website');
}

function browserContext(
  fingerprint: string,
  audience: 'demo' | 'website'
): string {
  return [
    `X_FINGERPRINT=${fingerprint}`,
    `X_ORIGIN=${encodeURIComponent(window.location.origin)}`,
    `USER_AGENT=${encodeURIComponent(navigator.userAgent)}`,
    `X_AUDIENCE=${audience}`,
    // Read per request: ob-agent refuses demo turns from automation and from
    // a page nobody is looking at.
    ...(audience === 'demo'
      ? [
          `X_WEBDRIVER=${navigator.webdriver ? 1 : 0}`,
          `X_VISIBILITY=${document.visibilityState}`,
        ]
      : []),
  ].join('&');
}
